import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@/app/core/current-user/current-user.service';

/** Route-guard factory: allow only if the current actor holds the given ProTax role. */
export function requirePermission(role: string): CanActivateFn {
    return () => {
        const currentUser = inject(CurrentUserService);
        const router = inject(Router);
        return currentUser.hasPermission(role) ? true : router.createUrlTree(['/zabranjen-pristup']);
    };
}

/** Route-guard: allow only super-admins (the EG super-admin flag on the resolved actor). */
export const requireSuperAdmin: CanActivateFn = () => {
    const currentUser = inject(CurrentUserService);
    const router = inject(Router);
    return currentUser.isSuperAdmin() ? true : router.createUrlTree(['/zabranjen-pristup']);
};
